export default "__VITE_PUBLIC_ASSET__ae55c428__"